<template>
  <div v-if="Object.keys(mobileMenuData).length > 0" class="mobile-menu">
    <div
      class="menu"
      :style="{ backgroundColor: theme ? theme.primaryColor : {} }"
    >
      <div v-if="mainMenuActive" class="Menu_container">
        <div class="menu_title">{{ mobileMenuData.title }}</div>
        <ul>
          <li v-if="isLogin" @click="toggleProfileMenu()">
            <img
              class="button settings"
              src="/images/settings-menu/profileico.svg"
            />
            {{ mobileMenuData.profile.title }}
          </li>
          <li @click="toggleLangMenu()">
            <img
              class="button settings"
              src="/images/settings-menu/langoptionico.svg"
            />
            {{ mobileMenuData.language.title }}
          </li>
          <li v-if="isLogin" @click="enterVR()">
            <img
              class="button settings"
              src="/images/settings-menu/entervrico.svg"
            />
            {{ mobileMenuData.enterVR }}
          </li>
          <li v-if="showUnsubBUtton" @click="unsubscribe()">
            <img
              class="button settings"
              src="/images/settings-menu/unsubscribe.svg"
            />
            {{ mobileMenuData.unsubscribe.title }}
          </li>
          <li @click="termsAndConditions()">
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            {{ mobileMenuData.terms }}
          </li>
          <li v-if="showMessageUs" @click="redirectToWhatsApp()">
            <img src="/images/settings-menu/whatsappIcon.png" />
            {{ mobileMenuData.contact.message }}
          </li>
          <li v-if="showFaqByDomain" @click="faq()">
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            {{ mobileMenuData.faq }}
          </li>
          <li
            v-if="isCreditCardProduct || productName === 'xrstudios'"
            @click="redirectToHelpPage()"
          >
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            {{ mobileMenuData.helpCenter }}
          </li>
          <li v-if="isCreditCardProduct" @click="redirectToRefundPolicy()">
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            {{ mobileMenuData.refundPolicy }}
          </li>
          <li v-if="isCreditCardProduct" @click="redirectToPrivacyPolicy()">
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            {{ mobileMenuData.privacyPolicy }}
          </li>
          <li v-if="showContactForm" @click="redirectToCustomerCarePage()">
            <img
              class="button settings"
              src="/images/settings-menu/customer-care.png"
            />
            {{ mobileMenuData.contact.title }}
          </li>
          <li v-if="isLogin" @click="logout()">
            <img class="button settings" src="/images/settings-menu/exit.svg" />
            {{ mobileMenuData.logout }}
          </li>
          <li v-if="showImpressum" @click="redirectToImpressum">
            <img
              class="button settings"
              src="/images/settings-menu/termsico.svg"
            />
            Impressum
          </li>
          <li v-if="showWithdrawLink" @click="redirectToWithdrawPage">
            <img
              class="button settings"
              src="/images/settings-menu/cancel.png"
            />
            {{ mobileMenuData.withdrawFromContract }}
          </li>
          <li v-if="showWinnersPage" @click="winners()">
            <img
              class="button settings"
              src="/images/settings-menu/langoptionico.svg"
            />
            {{ mobileMenuData.winners }}
          </li>
          <li v-if="isXRLab360" @click="redirectToPricing()">
            <img
              class="button settings"
              src="/images/settings-menu/plans.png"
            />
            {{ mobileMenuData.pricing }}
          </li>
        </ul>
      </div>
      <div
        v-if="profileMenuActive"
        class="profile_container"
        :class="{ XRExperienceBHProfile: isXRExperienceBH }"
      >
        <div @click="toggleProfileMenu()" class="profile_menu">
          {{ mobileMenuData.title }}
        </div>
        <div class="profile_data">
          <div class="profile_img">
            <img src="/images/settings-menu/avatarico.svg" />
            <p>
              {{ mobileMenuData.profile.subTitle }}
            </p>
          </div>
          <div>
            <label>{{ mobileMenuData.profile.phoneNumber }}</label>
            <input
              type="text"
              name="Mobile Number"
              value="0990 90 90"
              v-model="profile.msisdn"
              disabled
            />
          </div>
          <div v-if="isXRExperienceBH">
            <label>{{ mobileMenuData.profile.startDate }}</label>
            <input
              type="text"
              name="Start Date"
              value="2021-10-01"
              v-model="profile.startDate"
              disabled
            />
          </div>
          <div v-if="showSubscriptionEndDate">
            <label>{{ mobileMenuData.profile.endDate }}</label>
            <input
              type="text"
              name="End Date"
              value="2021-10-01"
              v-model="profile.renewalDate"
              disabled
            />
          </div>
          <div v-if="isXRExperienceBH">
            <label>{{ mobileMenuData.profile.subsStatus }}</label>
            <input
              type="text"
              name="Status"
              value="Active"
              v-model="profile.subsStatus"
              disabled
            />
          </div>
          <div v-if="isXRExperienceBH">
            <label>{{ mobileMenuData.profile.serviceName }}</label>
            <input
              type="text"
              name="Service"
              value=""
              v-model="profile.serviceName"
              disabled
            />
          </div>
          <div
            v-if="isXRExperienceBH"
            class="xracademyBH Unsub_btn"
            @click="requestUnsubscribe()"
          >
            <span>{{ mobileMenuData.unsubscribe.title }}</span>
          </div>
          <!-- <div
            v-if="isCreditCardProduct"
            class="reset_password"
            @click="toggleResetPasswordMenu()"
          >
            <p>{{ mobileMenuData.password_reset }}</p>
          </div> -->
        </div>
      </div>
      <div v-if="langMenuActive" class="lang_container">
        <div @click="toggleLangMenu()" class="lang_menu">
          {{ mobileMenuData.title }}
        </div>
        <div class="lang_title">
          {{ mobileMenuData.language.subTitle }}
        </div>
        <ul>
          <li
            v-for="language in availableLanguages"
            :class="{ selected: language.id === selectedLanguage }"
            v-bind:key="language.id"
            @click="selectLanguage(language)"
          >
            <img
              v-if="language.id === selectedLanguage"
              src="/images/settings-menu/langselection.svg"
            />
            <span :class="{ active_lang: language.id === selectedLanguage }">{{
              language.value
            }}</span>
          </li>
        </ul>
      </div>
      <!-- <div v-if="contactUsMenuActive" class="lang_container">
        <div @click="toggleContactMenu()" class="profile_menu">
          {{ mobileMenuData.title }}
        </div>
        <div class="lang_title">
          {{ mobileMenuData.contact.title }}
        </div>
        <div class="Unsub_info">
          <label>{{ mobileMenuData.contact.phoneNumber }} : 080000019051</label>
          <p>
            <label
              >{{ mobileMenuData.contact.email }} : deservices@cchelp.co</label
            >
          </p>
        </div>
      </div> -->
      <div v-if="UnsubMenuActive" class="Unsub_container">
        <div @click="unsubscribe()" class="Unsub_menu">
          {{ mobileMenuData.title }}
        </div>
        <div v-if="!this.idUnsubMenuActive" class="Unsub_info">
          <div class="Unsub_data">
            <img src="/images/settings-menu/avatarico.svg" />
            <p>{{ mobileMenuData.unsubscribe.title }}</p>
          </div>
          <div class="Unsub_info">
            <p>
              {{ mobileMenuData.unsubscribe.unsubInfo }}
            </p>
            <div class="Unsub_btn" @click="requestUnsubscribe()">
              <span>{{ mobileMenuData.unsubscribe.title }}</span>
            </div>
            <p style="color: red; font-size: 12px" v-if="showUnsubAPIStatus">
              {{ unsubscribeMessage }}
            </p>
          </div>
        </div>
        <div v-if="this.idUnsubMenuActive">
          <p class="id_domain_unsub_title">
            {{ mobileMenuData.unsubscribe.title }}
          </p>
          <ul class="id_domain_unsub">
            <li
              v-for="unsubscribeLink in idAavailableUnsubLinks"
              v-bind:key="unsubscribeLink.id"
              @click="requestUnsubscribe(unsubscribeLink.id)"
            >
              <span>{{ unsubscribeLink.value }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div @click="closeDialogBox()" class="close-button">
        <img src="/images/ui/exit-button.png" />
      </div>
    </div>
    <UnsubscribeConfirmation
      v-if="unsubscribeConfirmationActive"
      @cancel="closeUnsubscribeConfirmation"
      @confirm="confirmUnsubscribe"
      :unsubscribeConrfirmation="mobileMenuData.unsubscribe.confirmationMsg"
    />
  </div>
</template>

<script>
import {
  getLoginURL,
  redirectToLogin,
  redirectUnsubscribeForCreditCard,
} from "../utils/redirect.utils.js";
import { webstore } from "../helpers/auth-helpers.js";
import { getRockmanId } from "../helpers/auth-helpers.js";
import { getGenericData, transitionTo } from "../utils/aframe.utils";
import {
  getUnsubLink,
  UnsubscribePE,
  UnsubscribeSN,
  UnsubscribePT,
  UnsubscribeGH,
  UnsubscribeAPI,
  unsubscribe,
} from "../utils/unsub.utils";
import {
  getSelectedLanguage,
  setSelectedLanguage,
} from "../../aframe/utils/local-storage.utils";
import { sendOnClick } from "../utils/dataCollection.utils.js";
import { config } from "../helpers/domain-config";
import {
  isCreditCardProduct,
  isXRLAB,
  isXRLab360,
} from "../utils/isCreditCardProduct";
import { getUid } from "../helpers/auth-helpers";
import { MODAL_UTM_CAMPAIGN } from "../helpers/page-constants.js";
import { getDomainTheme } from "../utils/domains-theme.js";
import { getPlanAndPricingPageURL } from "../utils/pricing.utils.js";
import { getDomainConfigValue } from "../../utils/domain-config.js";
import UnsubscribeConfirmation from "./unsubscribe-confirmation.component.vue";
import { updateZendeskVisibility } from "../../utils/zendesk";

const allLanguages = [
  { id: "de", value: "Deutsch" },
  { id: "nl", value: "Dutch" },
  { id: "ar", value: "اللغة العربية" },
  { id: "in", value: "Indonesian" },
  { id: "es", value: "Español" },
  { id: "pl", value: "Polskie" },
  { id: "fr", value: "French" },
  { id: "cz", value: "Czech" },
  { id: "rs", value: "Srpski" },
  { id: "et", value: "Estonian" },
  { id: "vn", value: "Tiếng Việt" },
  { id: "th", value: "Thai" },
  { id: "se", value: "Swedish" },
];

export default {
  props: {},
  components: { UnsubscribeConfirmation },
  data: () => ({
    availableLanguages: [{ id: "en", value: "English" }],
    selectedLanguage: getSelectedLanguage(),
    profileMenuActive: false,
    langMenuActive: false,
    mainMenuActive: true,
    UnsubMenuActive: false,
    unsubscribeConfirmationActive: false,
    unsubscribePackageId: undefined,
    contactUsMenuActive: false,
    idUnsubMenuActive: false,
    showContactForm: config.getCustomerCareInfo().showCustomerCareLink,
    showUnsubBUtton:
      getUnsubLink() !== null ||
      isCreditCardProduct ||
      config.subdomain === "sn" ||
      config.subdomain === "pt" ||
      config.subdomain === "gh" ||
      config.subdomain === "pe" ||
      (config.subdomain === "app" && config.productName === "aulaxr-mx") ||
      (config.subdomain === "rs" && config.productName === "mobilnivr"),

    profile: {
      msisdn: webstore.getProperty("msisdn"),
      renewalDate:
        webstore.getProperty("renewalDate") ||
        webstore.getProperty("expiryDate"),
      startDate: webstore.getProperty("startDate"),
      subsStatus: webstore.getProperty("status"),
      serviceName: webstore.getProperty("serviceName"),
    },
    showSubscriptionEndDate: getSelectedLanguage() !== "nl",
    isXRExperienceBH:
      config.productName === "xr-experience" && config.subdomain === "bh",
    mobileMenuData: {},
    isCreditCardProduct: isCreditCardProduct,
    isLogin: getUid(),
    showMessageUs: config.getWhatsAppLink().showWhatsAppLink,
    errorMessage: "",
    showUnsubAPIStatus: "",
    showImpressum: config.getImpressumLink().showImpressum,
    showWinnersPage: config.subdomain === "za",
    showWithdrawLink: getDomainConfigValue("showWithdrawLink"),
    showUnsubscribeConfirmationMsg: getDomainConfigValue("showUnsubscribeConfirmationMsg"),
    idAavailableUnsubLinks: [
      { id: "PKG1", value: "Paket 3 hari" },
      { id: "PKG2", value: "Paket 5 hari" },
    ],
    theme: getDomainTheme(config.productName),
    productName: config.productName,
    isXRLab360: isXRLab360,
    LPLinkConfiguration: getDomainConfigValue("landingPageLink"),
  }),

  computed: {
    showFaqByDomain() {
      return (
        this.isCreditCardProduct ||
        (config.productName === "afri-verse" && config.subdomain === "gh")
      );
    },
    unsubscribeMessage() {
      const unsubscribe =
        this.mobileMenuData && this.mobileMenuData.unsubscribe;
      if (!unsubscribe) return "";
      const status = this.showUnsubAPIStatus;
      const data = unsubscribe || {};
      if (status === "error") return data.errorMsg || "";
      if (status === "success") return data.successMsg || "";
      return "";
    },
  },

  async created() {
    const { mobileMenu } = await getGenericData();
    this.mobileMenuData = mobileMenu;

    if (this.isXRExperienceBH) {
      this.mobileMenuData.profile.title =
        this.mobileMenuData.profile.accountTitle;
      this.mobileMenuData.profile.subTitle =
        this.mobileMenuData.profile.accountSubtitle;
    }

    if (
      ["qa", "om", "sa", "ae", "iq", "kw", "bh", "eg"].indexOf(
        config.subdomain
      ) >= 0
    )
      this.availableLanguages.push({ id: "ar", value: "اللغة العربية" });

    if (config.subdomain === "co")
      this.availableLanguages.push({ id: "es", value: "Español" });

    if (config.subdomain === "ca")
      this.availableLanguages.push({ id: "fr", value: "French" });

    if (config.subdomain === "cz")
      this.availableLanguages.push({ id: "cz", value: "Czech" });

    if (config.subdomain === "nl")
      this.availableLanguages.push({ id: "nl", value: "Dutch" });

    if (config.subdomain === "rs")
      this.availableLanguages.push({ id: "rs", value: "Srpski" });

    if (config.subdomain === "es")
      this.availableLanguages.push({ id: "es", value: "Español" });

    if (config.subdomain === "se")
      this.availableLanguages.push({ id: "se", value: "Swedish" });

    if (config.subdomain === "ee")
      this.availableLanguages.push(
        { id: "et", value: "Estonian" },
        { id: "rs", value: "Srpski" }
      );

    if (config.subdomain === "demo")
      this.availableLanguages.push(...allLanguages);

    if (config.subdomain === "de")
      this.availableLanguages.push({ id: "de", value: "Deutsch" });

    if (config.subdomain === "id" || config.subdomain === "id-tel")
      this.availableLanguages.push({ id: "in", value: "Indonesian" });

    if (config.subdomain === "pl")
      this.availableLanguages.push({ id: "pl", value: "Polskie" });

    if (config.subdomain === "th" || config.subdomain === "thd")
      this.availableLanguages.push({ id: "th", value: "Thai" });
    if (config.subdomain === "pk")
      this.availableLanguages.push({ id: "ar", value: "اللغة العربية" });
    if (config.subdomain === "portal" && config.productName !== "hkxr-a")
      this.availableLanguages.push(
        { id: "fr", value: "French" },
        { id: "de", value: "German" },
        { id: "es", value: "Spanish" }
        // { id: "en", value: "Italian" }
      );
    if (config.subdomain === "ch")
      this.availableLanguages.push(
        { id: "fr", value: "French" },
        { id: "de", value: "German" },
        { id: "it", value: "Italian" }
      );
    if (config.subdomain === "pe" || config.subdomain === "mx" || (config.subdomain === "app" && config.productName === "aulaxr-mx"))
      this.availableLanguages.push({ id: "es", value: "Spanish" });
    if (
      (config.subdomain === "sn" && isXRLAB) ||
      (config.subdomain === "dz" && config.productName === "xr-zone")
    )
      this.availableLanguages.push({ id: "fr", value: "French" });
    if (config.productName === "hkxr-a")
      this.availableLanguages.push({ id: "zh-Hant-HK", value: "Chinese" });
    if (config.subdomain === "app" && config.productName === "xrstudios")
      this.availableLanguages.push({ id: "nl", value: "Dutch" });
    if (config.subdomain === "pt")
      this.availableLanguages.push({ id: "pt", value: "Portuguese" });
    if (config.subdomain === "ph")
      this.availableLanguages.push({ id: "fil", value: "Filipino" });
    if (config.subdomain === "jp")
      this.availableLanguages.push({ id: "ja", value: "日本語" });
    if (config.subdomain === "thtd")
      this.availableLanguages.push({ id: "th", value: "Thai" });
    if (config.subdomain === "si")
      this.availableLanguages = [{ id: "sl", value: "Slovenian" }];
  },
  methods: {
    fetchProfileData() {
      const storedMsisdn = webstore.getProperty("msisdn");
      if (!this.profile.msisdn || this.profile.msisdn !== storedMsisdn) {
        this.profile.msisdn = webstore.getProperty("msisdn");
        this.profile.renewalDate =
          webstore.getProperty("renewalDate") ||
          webstore.getProperty("expiryDate");
      }
    },
    showError(msg) {
      this.showUnsubAPIStatus = msg;
    },
    hideError() {
      this.showErrorMessage = false;
      this.errorMessage = "";
    },
    redirectToCustomerCarePage() {
      const customerCareLink = config.getCustomerCareInfo().customerCareLink;
      if (customerCareLink) window.open(customerCareLink, "_blank");
    },
    redirectToWhatsApp() {
      const messageUsLink = config.getWhatsAppLink().whatsAppLink;
      if (messageUsLink) window.open(messageUsLink, "_blank");
    },

    closeDialogBox() {
      this.closeUnsubscribeConfirmation();
      this.profileMenuActive = false;
      document.body.classList.remove("zendesk-profile-active");
      updateZendeskVisibility();
      this.langMenuActive = false;
      this.mainMenuActive = true;
      this.UnsubMenuActive = false;
      this.$emit("close");
    },

    toggleProfileMenu() {
      this.fetchProfileData();
      this.mainMenuActive = !this.mainMenuActive;
      this.profileMenuActive = !this.profileMenuActive;
      document.body.classList.toggle(
        "zendesk-profile-active",
        this.profileMenuActive
      );
      updateZendeskVisibility();
      if (this.profileMenuActive) {
        document.body.classList.add("mobile-menu-active");
      }
    },
    // toggleResetPasswordMenu() {
    //   this.$emit("close");
    //   redirectToLogin();
    // },

    toggleContactMenu() {
      this.fetchProfileData();
      this.mainMenuActive = !this.mainMenuActive;
      this.contactUsMenuActive = !this.contactUsMenuActive;
      if (this.contactUsMenuActive) {
        document.body.classList.add("mobile-menu-active");
      }
    },

    toggleLangMenu() {
      this.mainMenuActive = !this.mainMenuActive;
      this.langMenuActive = !this.langMenuActive;
      if (this.langMenuActive) {
        document.body.classList.add("mobile-menu-active");
      }
    },

    enterVR: function () {
      this.$emit("close");
      document.querySelector("#enter-vr-button").click();
    },

    unsubscribe: function () {
      this.mainMenuActive = !this.mainMenuActive;
      this.UnsubMenuActive = !this.UnsubMenuActive;
      if (config.subdomain === "id") {
        this.idUnsubMenuActive = !this.idUnsubMenuActive;
      }
      if (this.UnsubMenuActive) {
        document.body.classList.add("mobile-menu-active");
      }
    },

    requestUnsubscribe: function (pkgId) {
      if (!this.showUnsubscribeConfirmationMsg) {
        this.redirectToUnsubPage(pkgId);
        return;
      }
      this.unsubscribePackageId = pkgId;
      this.unsubscribeConfirmationActive = true;
    },
    closeUnsubscribeConfirmation: function () {
      this.unsubscribeConfirmationActive = false;
      this.unsubscribePackageId = undefined;
    },
    confirmUnsubscribe: function () {
      const pkgId = this.unsubscribePackageId;
      this.closeUnsubscribeConfirmation();
      this.redirectToUnsubPage(pkgId);
    },
    redirectToUnsubPage: function (pkgId) {
      if (isCreditCardProduct) {
        redirectUnsubscribeForCreditCard(MODAL_UTM_CAMPAIGN);
        return;
      }

      const handler = unsubscribe(config.subdomain);

      if (handler) {
        handler
          .then((resp) => {
            if (resp === true) {
              sendOnClick({
                contentName: "optout",
                redirectUrl: getLoginURL().href,
              });
              this.showError("success");
              if (this.LPLinkConfiguration) {
                window.location.href = this.LPLinkConfiguration;
              }
            } else {
              this.showError("error");
            }
          })
          .catch((err) => {
            this.showError(handler.errorMsg);
          });
      } else {
        const redirectUrl = getUnsubLink(pkgId);
        if (typeof redirectUrl === "string") {
          window.location.href = redirectUrl;
        }
      }
    },
    redirectToPricing: function () {
      const redirectUrl = getPlanAndPricingPageURL(config.productName);
      if (redirectUrl) {
        window.open(redirectUrl, "_blank");
      }
    },
    logout: function () {
      this.$emit("close");
      sendOnClick({ contentName: "logout", redirectUrl: getLoginURL().href });
      redirectToLogin();
    },

    termsAndConditions: function () {
      this.$emit("close");
      transitionTo(["terms-and-conditions"]);
    },
    winners: function () {
      this.$emit("close");
      transitionTo(["winners"]);
    },

    selectLanguage: function (language) {
      setSelectedLanguage(language.id);
      window.location.reload();
    },
    faq: function () {
      this.$emit("close");
      transitionTo(["faq"]);
    },
    redirectToHelpPage: function () {
      this.$emit("close");
      transitionTo(["help-center"]);
    },
    redirectToRefundPolicy: function () {
      this.$emit("close");
      transitionTo(["refund-policy"]);
    },
    redirectToPrivacyPolicy: function () {
      this.$emit("close");
      transitionTo(["privacy-policy"]);
    },
    redirectToImpressum: function () {
      const impressumLink = config.getImpressumLink().impressumLink;
      if (impressumLink) window.open(impressumLink, "_blank");
    },
    redirectToWithdrawPage: function () {
      const rockmanId = getRockmanId();
      const msisdn = webstore.getProperty("msisdn");
      const { subdomain, productName, country, language } = config;
      window.open(
        `https://checksubscription.com/withdraw?c=${country}&product=${productName}&country=${country}&language=${this.selectedLanguage}&rockmanId=${rockmanId}&msisdn=${msisdn}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss">
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  color: white;
  width: 100vw;
  height: 100vh;
  pointer-events: none;

  .menu {
    font-family: "Lato", helvetica bold;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20%;
    background-color: black;
    transform: translate(-50%, -50%);
    vertical-align: center;
    pointer-events: all;
    padding: 12px 20px;
    border-radius: 10px;

    @media screen and (device-height: 480px) {
      top: 56% !important;
    }
    ul {
      list-style: none;
      padding: 0;
      width: 100%;
      margin: 1% 0% 0%;
    }

    li {
      display: flex;
      align-items: center;
      padding: 11px 0;
      pointer-events: all;
      cursor: pointer;
      &:last-child {
        margin-bottom: 20px;
      }
      &:hover {
        background-color: rgba(64, 64, 64, 1);
        border-radius: 8px;
      }
      img {
        width: 25px;
        height: 25px;
        padding: 0 18px;
        //transform: translateY(8px);

        &.vr {
          transform: translateY(17px);
        }
      }
    }

    .close-button {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -14px;
      right: -14px;
      border-radius: 15px;
      width: 30px;
      height: 30px;
      text-align: center;
      background-color: white;
      cursor: pointer;
      color: black;
      font-family: "Free Sans Bold";

      img {
        width: 100%;
      }
    }
    .lang_container {
      height: 324px;
      ul {
        height: 72%;
        overflow-y: scroll;
        li {
          justify-content: center;
          font-size: 18px;
          font-weight: 500;
          margin: 0;
          padding: 10px 17px;
          cursor: pointer;

          img {
            position: relative;
            right: 12px;
            width: 15px;
            transform: translateY(-1px);
            padding: 0;
          }
          .active_lang {
            margin-right: 9px;
          }
        }
        .selected {
          color: #2dceef;
        }
        .disabled {
          opacity: 0.2;
        }
      }
      .lang_title {
        text-align: center;
        font-size: 16px;
        margin-top: 7%;
        margin-bottom: 20px;
      }
    }
    .profile_container {
      height: 324px;
      .profile_data {
        .profile_img {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            width: 25%;
          }
        }
      }
      label {
        display: block;
        margin-top: 5%;
        font-size: 11px;
        color: #a5a9a9;
      }
      input {
        font-size: 14px;
        border: none;
        color: #ffffff;
        padding: 3% 0% 2% 0%;
        border-bottom: 1px solid #ffffff;
        background: #000000;
        outline: none;
        width: 100%;
      }
      .reset_password {
        p {
          text-decoration: underline;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .profile_container.XRExperienceBHProfile {
      height: auto;
    }
    .Unsub_container {
      height: 324px;
      .Unsub_data {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          width: 25%;
        }
      }
      .Unsub_info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 5%;

        .Unsub_btn {
          cursor: pointer;
          background: linear-gradient(
            90deg,
            rgba(45, 239, 224, 1) 0%,
            rgba(45, 155, 239, 1) 57%,
            rgba(53, 237, 251, 1) 100%
          );
          width: 80%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 60px;
          padding: 18px 0px;
          //margin-top: 10%;
        }
      }
      .id_domain_unsub,
      .id_domain_unsub_title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        li {
          font-size: 18px;
          font-weight: 500;
          margin: 0;
          padding: 10px 17px;
          cursor: pointer;
        }
      }
    }
    .xracademyBH.Unsub_btn {
      cursor: pointer;
      background: linear-gradient(
        90deg,
        rgba(45, 239, 224, 1) 0%,
        rgba(45, 155, 239, 1) 57%,
        rgba(53, 237, 251, 1) 100%
      );
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 60px;
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 1024px) {
    .menu {
      width: 30%;
    }
  }
  @media screen and (max-width: 680px) {
    .menu {
      padding: 20px 20px 0px;
      width: 75%;
      .Menu_container {
        margin-left: 20px;

        .menu_title {
          font-size: 19px;
          font-weight: 600;
        }
        ul {
          li {
            font-size: 19px;
            font-weight: 500;
            margin-left: 0;

            img {
              width: 30px;
              height: 30px;
            }
          }
        }
      }
      .lang_container {
        height: 357px;
        .lang_title {
          margin-top: 12%;
          font-size: 16px;
        }
      }
      .profile_container,
      .Unsub_container {
        height: 357px;
      }
      .close-button {
        top: -14px;
        right: -12px;
      }
    }
  }
  @media screen and (max-width: 360px) {
    .menu {
      top: 51%;

      .Menu_container {
        margin-left: 25px;
        ul {
          li {
            font-size: 16px;
          }
        }
      }
      .close-button {
        top: -14px;
        right: -14px;
      }
      .lang_container {
        .lang_menu {
          padding: 0% 8%;
        }
      }
      .profile_container {
        .profile_menu {
          padding: 0 7%;
        }
        .profile_data {
          padding: 7%;
        }
      }
      .Unsub_container {
        .Unsub_menu {
          padding-left: 25px;
        }
        .Unsub_info {
          padding: 0 20px;
        }
      }
    }
  }
  @media screen and (max-width: 825px) and (orientation: landscape) {
    .menu {
      padding: 15px 20px;
      //height: 280px;
      width: 35%;
      margin-top: 3%;

      .close-button {
        top: -15px;
        right: -15px;
      }
      .Menu_container {
        margin-left: 20px;

        .menu_title {
          font-size: 15px;
          font-weight: 600;
        }
        ul {
          margin: 0;
          li {
            padding: 8px 0px;
            font-size: 17px;
            margin-left: 0;
            margin: 0;

            img {
              width: 25px;
              height: 25px;
            }
          }
        }
      }
      .lang_container,
      .Unsub_container {
        height: 264px;
      }
      .profile_container {
        height: 264px;
        .profile_data {
          .profile_img {
            img {
              width: 22%;
            }
          }
        }
      }
      .Unsub_container {
        .Unsub_info {
          p {
            margin: 0;
          }
          .Unsub_btn {
            margin-top: 4%;
            padding: 15px 0px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 668px) and (orientation: landscape) {
    .menu {
      margin-top: 4%;

      .lang_container {
        .lang_menu {
          padding-left: 5%;
        }
      }
      .close-button {
        top: -11px;
      }
    }
  }
  @media screen and (max-width: 568px) and (orientation: landscape) {
    .menu {
      margin-top: 4% !important;
      padding: 6px 20px;
      width: 45%;
      height: 253px;

      ul {
        li {
          //padding: 6px 0px !important;

          img {
            width: 22px !important;
            height: 22px !important;
          }
        }
      }
      .Unsub_container {
        padding: 0px 15px;
        .Unsub_info {
          margin-top: 0%;
          .Unsub_btn {
            margin-top: 4%;
          }
        }
      }
    }
    .profile_container {
      .profile_data {
        p {
          margin: 0;
        }
        .profile_img {
          height: 27%;
          font-size: 13px;
          margin-bottom: 10%;
          img {
            width: 25% !important;
          }
        }
      }
      input {
        font-size: 15px !important;
      }
      .profile_menu {
        padding-left: 7%;
      }
    }
  }
}
</style>
